// VendorStoreApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'VendorStore'];

// Enhance the base API service by adding entication-related tag types
const VendorStoreApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createVendorStore: build.mutation({
            query: ({ user_id,Product_id,shopProfile_id }) => ({
              url: `/vendor-store/${user_id}/${Product_id}/${shopProfile_id}`,
              method: 'POST',
              data:{}, // Send an empty object
            }),
            invalidatesTags: ['VendorStore'],  // Invalidate ShopProfiles tags after creation
          }),
      // Fetch VendorStore query (GET request to /me)
      getVendorStoreByUser: build.query({
        query: (userId) => ({
          url: `/vendor-store/user/${userId}`,
        }),
        providesTags: ['VendorStore'],
      }),  
      // ✅ Check if VendorStore entry exists for user_id and product_id
      checkVendorStoreExists: build.query({
        query: ({ user_id, product_id }) => ({
          url: `/vendor-store/exists/${user_id}/${product_id}`,
        }),
        providesTags: ['VendorStore'],
      }),
       // Fetch VendorStore query (GET request to /me)
       getVendorStore: build.query({
        query: () => ({
          url: `/vendor-store`,
        }),
        providesTags: ['VendorStore'],
      }),  
      getPaginatedVendorStores: build.query({
        query: ({ page, size, sort, userId, productName, categoryId, subCategoryId, shopProfileId }) => {
          const params = new URLSearchParams();
          params.append("page", page);
          params.append("size", size);
  
          // Optional parameters
          if (sort) {
            if (Array.isArray(sort) && sort.length === 2) {
              // Join the sort field and order as "id,desc"
              params.append("sort", `${sort[0]},${sort[1]}`);
            } else if (Array.isArray(sort)) {
              // Handle multiple sort parameters (e.g., ["id,desc", "name,asc"])
              params.append("sort", sort.join(","));
            } else {
              // Handle single sort parameter (e.g., "id,desc")
              params.append("sort", sort);
            }
          }
  
          if (userId) params.append("userId", userId); // Add userId parameter
          if (productName) params.append("productName", productName);
          if (categoryId) params.append("categoryId", categoryId);
          if (subCategoryId) params.append("subCategoryId", subCategoryId);
          if (shopProfileId) params.append("shopProfileId", shopProfileId);
  
          return {
            url: "/vendor-store/paginatedStore",
            params,
          };
        },
        providesTags: ["VendorStore"],
      }),
       // Delete   mutation (DELETE request  )
       deleteVendorStore: build.mutation({
        query: (id) => ({
          url: `/vendor-store/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['VendorStore'], // Invalidate the user tag after deletion
      }),
    }),
    overrideExisting: false,
  });

export default VendorStoreApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateVendorStoreMutation,
    useGetVendorStoreByUserQuery,
    useCheckVendorStoreExistsQuery,
   useGetVendorStoreQuery,
   useDeleteVendorStoreMutation,
   useGetPaginatedVendorStoresQuery

} = VendorStoreApi;
 